export const products = [
    {
        type: "Urad Mogar Platinum",
        name: "Split Dehusked Black Gram (Bold)",
        img: "/images/UradMogar-Platinum.png",
    },
    {
        type: "Urad Mogar Premium",
        name: "Split Dehusked Black Gram (Medium)",
        img: "/images/UradMogar-Premium.png",
    },
    {
        type: "Moong Mogar Gold",
        name: "Split Dehusked Green Gram (Medium)",
        img: "/images/MoongMogar-Gold.png",
    },
    {
        type: "Moong Mogar Premium",
        name: "Split Dehusked Green Gram (Bold)",
        img: "/images/MoongMogar-Premium.png",
    },
];
